import { useLingui } from "@lingui/react/macro";
import { Text, Title } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DocsContent } from "@/components/docs/DocsContent.tsx";

export const Route = createFileRoute("/docs/data-use/terms-of-use")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useLingui();

  return (
    <DocsContent>
      <Title order={1} size="h2">{t`Terms of use`}</Title>
      <Text>{t`TODO: Lantmäteriet, GDPR, FRL`}</Text>
    </DocsContent>
  );
}
